import React from 'react';

/**
 * Skeleton - Sea Sand shimmering placeholder used while data is loading.
 *
 * Usage:
 *   <Skeleton className="h-4 w-32" />
 *   <SkeletonAvatar size={40} />
 *   <SkeletonCard />
 *
 * The keyframes live in `index.css` (`@keyframes shimmer`).
 */
export const Skeleton = ({ className = '', ...rest }) => (
  <div
    className={`bg-[#F4ECD8] relative overflow-hidden rounded animate-pulse ${className}`}
    aria-hidden="true"
    {...rest}
  />
);

export const SkeletonAvatar = ({ size = 40 }) => (
  <div
    className="bg-[#F4ECD8] rounded-full animate-pulse shrink-0"
    style={{ width: size, height: size }}
    aria-hidden="true"
  />
);

export const SkeletonText = ({ lines = 3 }) => (
  <div className="space-y-2" aria-hidden="true">
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton
        key={i}
        className={`h-3 ${i === lines - 1 ? 'w-2/3' : 'w-full'}`}
      />
    ))}
  </div>
);

/**
 * SkeletonPost - drop-in placeholder for one community feed post.
 */
export const SkeletonPost = () => (
  <article className="bg-white border border-[#EFE6CF] rounded-2xl p-5">
    <div className="flex items-start gap-3 mb-4">
      <SkeletonAvatar size={44} />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-3 w-32" />
        <Skeleton className="h-2.5 w-20" />
      </div>
    </div>
    <SkeletonText lines={3} />
    <div className="flex gap-2 mt-5">
      <Skeleton className="h-7 w-16 rounded-full" />
      <Skeleton className="h-7 w-16 rounded-full" />
      <Skeleton className="h-7 w-16 rounded-full" />
    </div>
  </article>
);

/**
 * SkeletonDashboardCard - drop-in placeholder for a dashboard tile.
 */
export const SkeletonDashboardCard = () => (
  <div className="bg-white border border-[#EFE6CF] rounded-2xl p-6 space-y-4">
    <Skeleton className="h-3 w-24" />
    <Skeleton className="h-6 w-3/4" />
    <SkeletonText lines={2} />
    <Skeleton className="h-2 w-full rounded-full" />
  </div>
);

export default Skeleton;
